import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useAuthModal } from "../auth/AuthModalContext";

// Login is optional app-wide, so a gated route doesn't dump the user on a
// dead-end page: it bounces them home and pops the login modal instead.
const ProtectedRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const { openAuth } = useAuthModal();

  useEffect(() => {
    if (!user) openAuth("login");
  }, [user, openAuth]);

  if (!user) {
    return <Navigate to="/homepage" replace />;
  }

  return children;
};

export default ProtectedRoute;
